export default __webpack_public_path__ + "static/media/none.da37c2fa.png";